import type { MoveList } from 'chessboard/model/move-list/types';
import { Game } from 'chessboard/model/game/types';

export { formatText, getPieceIconNameFromSan };

/**
 * Format san text for figurines and/or translations
 **/
function formatText({
  showFigurine = false,
  san = '',
  annotation = '',
  translations,
}: {
  showFigurine?: boolean;
  san: string;
  annotation?: string;
  translations?: MoveList.Translations;
}) {
  return `${san
    .split('')
    .map((char) => {
      if ('NBRQK'.includes(char) && showFigurine) {
        return;
      }

      if (!'NBRQK'.includes(char) || !translations) {
        return char;
      }

      return translations?.[char]();
    })
    .join('')}${annotation}`;
}

/**
 * Get the piece name, and returns null for pawns
 */
function getPieceIconNameFromSan(san: string): Game.Piece.Names | null {
  const lowerCasePieceName = san[0].toLowerCase();

  // avoiding b pawn and bishop ambiguity
  if (lowerCasePieceName === san[0]) {
    return null;
  }

  return Game.Piece.Names[lowerCasePieceName] ?? null;
}
